module.exports = __webpack_public_path__ + "img/back.026bc1bd.webp";